import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';
import { ReportPakAmount } from '../../../components/ReportPak/ReportPakAmount';
import { ReportPakAmountType } from '../../../../common/types/ReportTypes';

export const ReportPakAmountView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportPakAmountType>();

  const onSearch = async (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports.reportPakAmount(false, filter).then(dataReports => {
      setData(dataReports);
    });
  };

  return (
    <>
      <Filter onSearch={onSearch} reportName="Administracyjne kary pieniężne" />
      <ReportPakAmount
        data={data}
        reportName="Administracyjne kary pieniężne"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
      />
    </>
  );
};
